import * as React from 'react';
import { Link } from 'react-router-dom';

import { IconSize } from 'shared/entities/components/Icon';
import { ComponentType } from 'shared/entities/components/Component';
import { SelectorRightComponentProps } from 'shared/newEntities/components/Selector';

type RightComponentProps = SelectorRightComponentProps & {
  className?: string;
};

const RightIconComponent: React.FC<RightComponentProps> = ({
  Icon,
  action,
  iconStyle,
  className
}: RightComponentProps) => {
  if (action.type === ComponentType.link) {
    return (
      <Link
        className={className}
        to={action.to}
        onClick={action.onClick}
        target={action.target}
      >
        <Icon iconSize={IconSize.XM} iconStyle={iconStyle} />
      </Link>
    );
  }

  if (action.type === ComponentType.a) {
    return (
      <Icon
        iconSize={IconSize.XM}
        action={action}
        iconStyle={iconStyle}
        className={className}
      />
    );
  }

  return (
    <Icon
      action={action}
      iconSize={IconSize.XM}
      iconStyle={iconStyle}
      className={className}
    />
  );
};

export default RightIconComponent;
